import { api } from 'boot/betting-api'

const timeShift = '0'

function additionPayload(time_shift = true) {
  const result = {}

  if (time_shift) {
    result.time_shift = timeShift
  }

  // TODO: FAKE SESSION, удалить когда бэк сделает у себя
  // const FAKE_SESSION = localStorage.getItem('BK_SESSION')
  // if (privateApi && FAKE_SESSION) {
  //   result.session = FAKE_SESSION
  // }
  return result
}

const apiActions = {
  userInfo: { method: 'POST', url: '/user/info/' },
  basketAdd: { method: 'POST', url: '/basket/add/', params: additionPayload() },
  basketDelete: { method: 'POST', url: '/basket/delete/', params: additionPayload() },
  basketList: { method: 'POST', url: '/basket/list/', params: additionPayload() },
  basketClear: { method: 'POST', url: '/basket/clear/', params: additionPayload() },
  basketSave: { method: 'POST', url: '/basket/save/', params: additionPayload() },
  basketFast: { method: 'POST', url: '/basket/fast/', params: additionPayload() },
  slice: { method: 'POST', url: '/slice/', params: additionPayload() },
  stakes: { method: 'POST', url: '/stakes/', params: additionPayload() },
  resultsSportsList: { method: 'POST', url: '/results/sport/' },
  results: { method: 'POST', url: '/results/', params: additionPayload(60) },
  sports: { method: 'POST', url: '/sports/' },
  champs: { method: 'POST', url: '/champs/' },
  live: { method: 'POST', url: '/live/', params: additionPayload() },
  matches: { method: 'POST', url: '/matches/', params: additionPayload() },
  matchesCount: { method: 'POST', url: '/matches_count/', params: additionPayload(0) },
  matchresult: { method: 'POST', url: '/matchresult', params: additionPayload() },
  customSlice: { method: 'POST', url: '/custom_slice/', params: additionPayload() },
  favorites: { method: 'POST', url: '/favorites/', params: additionPayload(false) },
  favoritesList: { method: 'POST', url: '/favorites/list/', params: additionPayload(false) },
  languages: { method: 'POST', url: '/langs/' },
  tv: { method: 'GET', url: '/matches', baseURL: '/api_video' },
  history: { method: 'POST', url: '/user/history/', params: additionPayload() },
  getexchangelist: { method: 'POST', url: '/getexchangelist/' },
  cashout: { method: 'POST', url: '/user/cashout/' },
  topMatches: { method: 'POST', url: '/topmatches/', params: additionPayload(1) },
  widgetTopSport: { method: 'POST', url: '/widget_top_sport', params: additionPayload() },
  search: { method: 'POST', url: '/search/', params: additionPayload(0) },
  video: { method: 'POST', url: '/video/get_iframe_src', params: additionPayload(0) },
  specList: { method: 'POST', url: '/spec/', params: additionPayload() },
  specSet: { method: 'POST', url: '/spec/set/', params: additionPayload(false) },
}

export const ApiService = new Proxy(apiActions, {
  get(target, apiMethod) {
    return async function (params, query = null, apiConfig = {}) {
      const config = target[apiMethod]
      if (!config) {
        throw new Error('Api function not found')
      }

      const data = { ...(config.params || {}), ...params }
      const dataForAPI = {
        ...apiConfig,
        method: config.method,
        url: query ? config.url + query : config.url,
        data,
      }

      if (config.baseURL) {
        dataForAPI.baseURL = config.baseURL
      }

      return api(dataForAPI)
    }
  },
})
